import * as service from './service';

export const speakingSessionRoomStore = {
  service,
};
